interface NumberArrayMap {
  [index: string]: number[];
}

interface StringArray {
  [index: string]: string;
}

export default class SensorLimits {
  //  static tempScale =
  // chroma.scale(['violet', 'blue', 'green', 'orange', 'red']).domain([-50, 0, 10, 20, 50]).mode('hsl');
  // static humScale = chroma.scale(['orange', 'white', 'blue']).domain([0, 50, 100]).mode('hsl');

  public static severityColors: StringArray = {
    verygood: "#228b22",
    good: "#94a60d",
    moderate: "#ffd700",
    sufficient: "#ff8c00",
    bad: "#ff0000",
    verybad: "#8b0000"
  };
  // http://prawo.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20190001931

  public static sensorLimits: NumberArrayMap = {
    PM25: [13, 37, 61, 85, 121],
    PM10: [21, 61, 101, 141, 201],
    O3: [71, 121, 151, 181, 241],
    NO2: [41, 101, 151, 201, 401],
    SO2: [51, 101, 201, 351, 501]
  };

  public static PIPlimitNames = [
    "verygood",
    "good",
    "moderate",
    "sufficient",
    "bad",
    "verybad"
  ];
  public static PIPlimitNamesPL: StringArray = {
    verygood: "Bardzo dobry",
    good: "Dobry",
    moderate: "Umiarkowany",
    sufficient: "Dostateczny",
    bad: "Zły",
    verybad: "Bardzo zły"
  };

  public static getLimitName(measurement: string, value: number) {
    const limits: number[] = this.sensorLimits[measurement];
    for (let index = 0; index < limits.length; index++) {
      if (value < limits[index]) {
        return this.PIPlimitNames[index];
      }
    }
    return this.PIPlimitNames[limits.length];
  }

  public static getLimitColor(measurement: string, value: number) {
    let limitName = this.getLimitName(measurement, value);
    return this.severityColors[limitName];
  }

  public static getColor(limitName: string) {
    return this.severityColors[limitName];
  }
}
